<template>
  <div class="s-lottery" :style="{...defaultBg.style}">
    <div class="high-value-list">
      <div class="high-value-item-top" :i-id="item.id" :name="item.name" v-for="item in highValueList" :key="item.id" :style="{top: item.top, left: item.left, color: item.color, fontSize: item.fontSize}">余:{{ item.left_amount }}</div>
    </div>
    <div class="s-topic-bg-wrap">
      <SAnimateImage :width="defaultBg.style.width" :height="defaultBg.style.height" :src="defaultBg.src" mask=""></SAnimateImage>
    </div>
    <img v-if="btnLottery.src" :src="btnLottery.src" :style="{...btnLottery.style}" alt="" @click="lotteryFun">
  </div>
</template>

<script>

import SAnimateImage from '../AnimateImage/index.vue'

export default {
  name: 'SVersionLottery',
  components: { SAnimateImage },
  props: {
    defaultBg: {
      type: Object,
      required: true
    },
    activityId: {
      type: String,
      default: ''
    },
    lotteryCount: {
      type: String,
      default: '1'
    },
    btnLottery: {
      type: Object,
      default: () => {
        return {}
      }
    },
    request: {
      type: Function
    },
    showLimit: {
      type: Boolean,
      default: false
    },
    showList: {
      type: Array,
      default: () => []
    }
  },
  inject: {
    eventBus: {
      default: null
    },
    $MainWrap: {
      default: null
    }
  },
  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    }
  },
  data () {
    return {
      highValueList: []
    }
  },
  mounted () {
    this.requestLotteryInfo()
  },
  methods: {
    requestLotteryInfo () {
      if (this.showLimit) {
        this.requestAPI({
          url: '/v1/uni/info',
          method: 'get',
          params: { a_id: this.activityId }
        }).then((res) => {
          console.log(res, '-----sssss-----')
          if (res.groups && res.groups.length > 0) {
            const arr = []
            res.groups.forEach((item) => {
              this.showList.forEach((subitem) => {
                if (subitem.id == item.id) {
                  arr.push({
                    id: item.id,
                    left_amount: item.left_amount,
                    top: subitem.top,
                    left: subitem.left,
                    color: subitem.color,
                    fontSize: subitem.fontSize,
                    name: item.name
                  })
                }
              })
              this.highValueList = arr
            })
            console.log(this.highValueList, '-----this.highValueList-----')
          }
        }).catch((err) => {
          this.$message.error(err.msg || '系统错误')
        })
      }
    },
    // 点击抽奖按钮
    lotteryFun () {
      if (!window.$checkLogin()) return
      this.requestAPI({
        url: '/v1/uni/multiLottery',
        method: 'get',
        params: { a_id: this.activityId, count: Number(this.lotteryCount) }
      }).then((res) => {
        // type: 1 游戏道具 2 实物奖励 3 虚拟积分
        const materialsAll = [];
        res.forEach((item) => {
          item.materials.forEach((subitem) => {
            if (subitem.type !== 3) {
              materialsAll.push(subitem);
            }
          })
        })
        this.requestLotteryInfo()
        this.$MainWrap.openVersionDialogTipSuccess(materialsAll)
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.high-value-item-top {
  position: absolute;
  z-index: 1;
}
.s-lottery{
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  .total-progress{
    position: absolute;
    bottom: 366px;
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
  }
  .total-progress-0{
    left: 317px;
  }
  .total-progress-1{
    left: 627px;
  }
  .total-progress-2{
    left: 937px;
  }
  .total-progress-3{
    left: 1247px;
  }
  .total-progress-4{
    left: 1557px;
  }
}
</style>
